import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUndoRedoAnnotationsShortcutsProps } from '../containers/UndoRedoAnnotationsShortcuts.container';

library.add(faSearch);

export const UndoRedoAnnotationsShortcuts = observer((props: IUndoRedoAnnotationsShortcutsProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <Button
      onClick={props.onClick}
      disabled={!props.enabled}
      color='neutral'
      variant='topbar'
      tabIndex={-1}
      startDecorator={<FontAwesomeIcon icon={props.undo ? 'undo' : 'redo'} />}
    >
      {t(props.undo ? 'undo' : 'redo')}
    </Button>
  );
});
